import React, {useEffect, useRef} from 'react';
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import {allWeightCoefGroups} from "./WeightCoefficientsMap";
import WeightCoefficientsFormInput from "./WeightCoefficientsFormInput";

const WeightCoefficientsForm = ({initData, controlRef}) => {

    const controlRefCoefs = useRef(initData.map(x => ({name: x.name, ref: {}})));

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        for (const item of controlRefCoefs.current) {
            if (!item.ref.current.validateNotEmpty("Нужно указать значение!"))
                isValid = false;

            if (!item.ref.current.validateLength(8))
                isValid = false;

            if (!validateFloat(item.ref))
                isValid = false;
        }

        return isValid;
    }

    function getData() {
        return controlRefCoefs.current.map(x => ({name: x.name, value: parseFloat(x.ref.current.getText())}));
    }

    function renderGroup(group) {
        return <FormBlock key={group.name} title={group.title}>
            {group.items.map(renderGroupItem)}
        </FormBlock>
    }

    function renderGroupItem(item) {
        const data = initData.find(x => x.name === item.name);
        if (!data)
            return null;

        return <WeightCoefficientsFormInput
            key={item.name}
            controlRef={controlRefCoefs.current.find(y => y.name === item.name).ref}
            label={item.title}
            label2={`(${item.name})`}
            subLabel={item.description}
            widthLimit={200}
            initValue={data.value}
        />
    }

    function renderUnknownGroup() {
        const unknownInitData = [...initData];

        for (const group of allWeightCoefGroups) {
            for (const item of group.items) {
                const idx = unknownInitData.findIndex(x => x.name === item.name);
                if (idx >= 0)
                    unknownInitData.splice(idx, 1);
            }
        }

        if (unknownInitData.length === 0)
            return null;

        const unknownGroup = {
            name: "unknown",
            title: "Неизвестные (не добавленные в админку)",
            items: unknownInitData.map(x => ({name: x.name, title: "", description: ""})),
        }

        return renderGroup(unknownGroup);
    }

    return (
        <BaseSimpleItemEditorForm>
            {allWeightCoefGroups.map(renderGroup)}
            {renderUnknownGroup()}
        </BaseSimpleItemEditorForm>
    );
};

function validateFloat(controlRef) {
    const text = controlRef.current.getText();
    const regex = /^-?\d+(\.\d+)?$/
    const value = parseFloat(text);

    if (text.length > 9) {
        controlRef.current.setErrorMessage("Слишком длинное числовое значение!");
        return false;
    }

    if (!regex.test(text) || isNaN(value)) {
        controlRef.current.setErrorMessage("Неверно указано числовое значение! Введите целое число или дробное с использованием десятичной точки");
        return false;
    }

    if (value < 0) {
        controlRef.current.setErrorMessage("Не допускаются отрицательные значения!");
        return false;
    }

    return true;
}

export default WeightCoefficientsForm;